import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PatientService } from '../patient/patient.service';
import { SnackBarService } from 'src/app/framework/service/snack-bar.service';
import { MyReportsService } from '../../my-reports/my-reports.service';

@Component({
  selector: 'app-additional-analysis-request',
  templateUrl: './additional-analysis-request.component.html',
  styleUrls: ['./additional-analysis-request.component.scss']
})
export class AdditionalAnalysisRequestComponent implements OnInit {

  

  isAdditionalAnalysisReqConsent = false;
  showThankYou: boolean = false;

  constructor(
    private readonly pservice: PatientService,
    private readonly myReportsService: MyReportsService,
    private readonly snackBarService: SnackBarService,
    private dialogRef: MatDialogRef<AdditionalAnalysisRequestComponent>,
    
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.showThankYou = data?.showThankYou || false;
    console.log(
  "payload:",
  JSON.stringify(data));
  }

  ngOnInit(): void {
  }

  onBack(): void {
  this.dialogRef.close('back');
}



 onSubmit(): void {

  const patientId = localStorage.getItem('patientID');

  if (!patientId) {
    this.snackBarService.error('Patient ID not found');
    return;
  }

  this.pservice.getPatientDetails(patientId).subscribe({
    next: (patient) => {

      if (!patient) {
        this.snackBarService.error('Patient details are empty');
        return;
      }

      delete patient.createdDate;
      delete patient.updatedDate;

      const savePayload = {
        ...this.data.payload, 
        isAdditionalAnalysisReqConsent: this.isAdditionalAnalysisReqConsent
      };

      this.pservice.savePatientAnalysisRequest(savePayload).subscribe({
        next: () => {

          const notificationPayload = {
            ...this.data.originalData,
            isAdditionalAnalysisReqConsent: this.isAdditionalAnalysisReqConsent,
            patient: patient
          };

          this.pservice.sendAnalysisRequestNotification(notificationPayload).subscribe({
            next: () => {
              this.showThankYou = true;
            },
            error: (error) => {
              this.snackBarService.error(
                error?.error?.applicationMessage || 'Failed to send notification'
              );
            }
          });

        },
        error: (error) => {
          this.snackBarService.error(
            error?.error?.applicationMessage || 'Failed to save analysis request'
          );
        }
      });

    },
    error: (error) => {
      this.snackBarService.error(
        error?.error?.applicationMessage || 'Failed to fetch patient details'
      );
    }
  });
}



  onClose(): void {
    this.pservice.notifyAnalysisRequested(true); 
    this.myReportsService.notifyAnalysisRequested(true);
    this.dialogRef.close();
  }
}
